<template>
  <!-- first access screen, link sent by email to change password, already with registered user -->
  <div class="container-fluid py-2">
    <div class="row">
      <div class="col-sm-12 col-md-9 col-lg-5 mx-auto">
        <div class="card card-signin my-5 card-opacity">
          <div class="card-body">
            <img
              class="mx-auto rounded mx-auto d-block logo-image"
              alt="logoImage"
              :src="logoImage"
            />
            <h5 class="card-title text-center text-join">Nova senha</h5>
            <form
              class="form-signin"
              autocomplete="off"
              @submit.prevent="accessPortal"
            >
              <p class="text-join-center">
                A senha será alterada para o usuário abaixo.
              </p>
              <div class="form-label-group">
                <label for="userFirstAccess label-config">Usuário</label>

                <input
                  id="userFirstAccess"
                  class="form-control input-length"
                  :value="userLogin"
                  required
                  autocomplete="off"
                  autofocus
                  disabled
                />
              </div>
              <br />

              <div class="form-label-group">
                <label for="inputPnewPasswordFirstAccessassword label-config"
                  >Nova senha</label
                >

                <input
                  type="password"
                  id="newPasswordFirstAccess"
                  class="form-control input-length"
                  v-bind:class="{ 'is-invalid': errors.new_password }"
                  placeholder=" Digite uma nova senha"
                  v-model="newPassword"
                  required
                  autocomplete="off"
                  autofocus
                />
                <span v-if="errors.new_password" class="error">
                  <ul>
                    <li v-for="msg in errors.new_password">{{ msg }}</li>
                  </ul>
                </span>
              </div>
              <br />
              <div class="form-label-group">
                <label for="confirmNewPasswordFirstAccess label-config"
                  >Repetir senha</label
                >

                <input
                  type="password"
                  id="confirmNewPasswordFirstAccess"
                  class="form-control input-length"
                  v-bind:class="{ 'is-invalid': errors.new_password }"
                  placeholder="Repita sua nova senha"
                  v-model="newPasswordConfirmation"
                  required
                  autocomplete="off"
                  autofocus
                />
              </div>
              <p class="text-align-center">
                A senha deve conter no mínimo 8(oito) caracteres, contendo
                letras, números e símbolos. O sistema diferencia letras
                maiúsculas de minúsculas.
              </p>
              <div class="access-center">
                <button
                  class="btn btn-lg access-first"
                  id="sendFirstAccess"
                  type="submit"
                >
                  Acessar
                </button>
                <br /><br />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "FirstAccess",
  data() {
    return {
      logoImage: "",
      userLogin: "",
      newPassword: "",
      newPasswordConfirmation: "",
      token: "",
      key: "",
      userId: "",
      groupId: "",
      errors: [],
    };
  },

  mounted() {
    let group = this.$route.query.group;
    this.token = this.$route.query.token;
    this.key = this.$route.query.key;

    if (group) {
      axios.get(`${process.env.API_PBM}/group/${group}`).then((response) => {
        let background = response.data.data.background;
        let logo = response.data.data.logo;

        localStorage.removeItem("userLogged");
        localStorage.setItem("group", group);
        localStorage.setItem("themeColor", response.data.data.skin);
        localStorage.setItem("logo", logo);
        localStorage.setItem("logoVazado", response.data.data.logo_vazado);

        this.groupId = response.data.data.id;
        if (background != null) {
          document.body.className = "background-login";
          document.body.style.backgroundImage = `url("${background}")`;
        }
        this.logoImage = logo != null ? logo : "";
      });
    }
    if (this.token && this.key) {
      axios
        .get(
          `${process.env.API_PBM}/user/password/info/${this.token}/${this.key}`
        )
        .then((response) => {
          this.userLogin = response.data.data.user_login;
          this.userId = response.data.data.user_id;
        });
    }
  },
  methods: {
    accessPortal: function () {
      let data = {
        token: this.token,
        key: this.key,
        new_password: this.newPassword,
        new_password_confirmation: this.newPasswordConfirmation,
      };
      axios
        .put(
          `${process.env.API_PBM}/user/password/reset/${this.userId}`,
          this.$qs.stringify(data)
        )
        .then((response) => {
          let user = this.userLogin;
          let password = this.newPassword;
          let grp_id = this.groupId;
          this.$store
            .dispatch("login", { user, password, grp_id })
            .then(() => this.$router.push({ name: "home" }))
            .catch((err) => {
              if (err.response.status !== 401) {
                return Vue.$toast.error(err.response.data.message, {
                  position: "top-right",
                  duration: 5000,
                });
              }
              return Vue.$toast.error('Ops! Erro de login.', {
                    position: "top-right",
                    duration: 5000,
                  });
            })
        })
        .catch((error) => {
          this.errors = error.response.data.message;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-top: 5px;
  margin-bottom: 40px;
}

.input-length {
  margin: 0 auto;
}

.input-user {
  background: transparent;
  border: none;
  border-bottom: 1px solid #000000;
  outline: none;
  box-shadow: none;
}

.card-opacity {
  background: rgba(255, 255, 255, 0.9);
  border: none;
}

label {
  display: inline-block;
  font-size: 16px;
  color: rgb(100, 95, 95);
}

input {
  font-size: 14px;
}

.error {
  display: inline-block;
  margin-top: 5px;
  margin-left: -22px;
  font-size: 13px;
  color: #b0191a;
  margin-right: 45px;
  margin-bottom: -15px;
}

.text-align-center {
  margin-top: 5px;
  color: rgb(100, 95, 95);
  font-size: 14px;
}
.text-join-center {
  color: rgb(100, 95, 95);
  font-size: 18px;
  text-align: center;
}

.access-first {
  background-color: var(--colorDefault);
  color: #fff;
  width: 35%;
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
}
.access-first:hover {
  background-color: var(--colorDefaultActiveHover);
}
.access-center {
  text-align: center;
}
@media only screen and (max-width: 900px) {
  label {
    display: inline-block;
    font-size: 17px;
    color: rgb(100, 95, 95);
    margin-bottom: 5px;
  }
  .text-align-center {
    margin-top: 5px;
    margin-left: 5px;
    color: rgb(100, 95, 95);
    font-size: 14px;
  }
  .error {
    display: inline-block;
    margin-top: 5px;
    margin-left: 1px;
    font-size: 12px;
    color: #b0191a;
    margin-right: 45px;
    margin-bottom: -15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/firstAccess/FirstAccess.vue